module.exports = __webpack_public_path__ + "static/img/icon-footer-logo.e5cf448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-footer-logo.svg
// module id = yI9Y
// module chunks = 21